
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 46","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#4FA2B7","fill-rule":"nonzero","cx":"22.5","cy":"22.5","r":"22.5"}}),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M25.09 34.076c0 1.33-1.082 2.41-2.411 2.41a2.413 2.413 0 01-2.411-2.41 2.414 2.414 0 012.41-2.412c1.33 0 2.412 1.082 2.412 2.412m-3.186-23.832v19.948a3.966 3.966 0 00-3.155 4.384 3.974 3.974 0 003.48 3.435 3.967 3.967 0 004.41-3.935 3.963 3.963 0 00-3.188-3.884V10.244"}}),_c('path',{attrs:{"d":"M33.798 13.188a.206.206 0 01-.204.205h-2.315a.207.207 0 01-.208-.205v-2.315c0-.114.093-.204.208-.204h2.315c.111 0 .204.09.204.204v2.315zM33.59 9.12H31.28c-.97 0-1.755.788-1.755 1.754v2.315c0 .967.785 1.755 1.755 1.755h.384v1.456a3.4 3.4 0 01-2.458 3.266L24.69 20.97v1.612l4.946-1.43A4.97 4.97 0 0033.21 16.4v-1.456h.385c.967 0 1.754-.788 1.754-1.755v-2.315c0-.966-.787-1.754-1.758-1.754zM12.92 18.116a1.569 1.569 0 01-1.565-1.566 1.565 1.565 0 111.565 1.566zm3.232 6.467a3.402 3.402 0 01-2.457-3.27v-1.75a3.114 3.114 0 00-.18-6.071 3.118 3.118 0 00-3.706 3.058c0 1.448.994 2.665 2.336 3.013v1.75a4.956 4.956 0 003.577 4.758l4.943 1.429v-1.612l-4.513-1.305z"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/cableFill.svg